import { Typography } from '@ovComponents/1-primative/typography/typography';
import { Alert } from '@ovComponents/2-component/alert/alert';
import { useTranslation } from 'react-i18next';

export const NoObjectsToArchive = () => {
  const { t } = useTranslation(['workflowCompletions']);

  return (
    <Alert severity='info'>
      <Typography variant='bodyLarge'>
        {t('workflowCompletions:archiveObjects.noObjectsToArchive')}
      </Typography>
    </Alert>
  );
};
